import { cn } from "@newxsystems/shared";
import { RavioliAction } from "../RavioliAction/RavioliAction";
import { RavioliMedia } from "../RavioliMedia/RavioliMedia";
import { RavioliRichText } from "../RavioliRichText/RavioliRichText";
import type { IHeroBackgroundImageProps } from "./HeroBackgroundImage.props";

export const HeroBackgroundImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
}: IHeroBackgroundImageProps) => {
  const centered = alignment === "center";
  const hasContent = Boolean(eyebrow || heading || description || buttons?.length);
  return (
    <div className="relative mx-auto flex min-h-[44rem] w-full max-w-[120rem] overflow-hidden bg-ink md:min-h-[60rem]">
      <RavioliMedia
        className="absolute inset-0 h-full"
        imageClassName="object-cover"
        media={image.image}
        priority
        sizes="(min-width: 1600px) 1600px, 100vw"
      />
      <div className="absolute inset-0 bg-ink/45" />
      {hasContent ? (
        <div className="ravioli-container relative z-10 flex w-full items-end py-8 md:py-12 lg:py-16">
          <div
            className={cn(
              "w-full max-w-[52rem] mb-12 lg:mb-20 xl:mb-24 border border-primary bg-surface p-6 text-ink shadow-ravioli-action-lg md:p-10",
              centered && "mx-auto text-center",
            )}
          >
            <div className={cn("flex flex-col gap-5", centered && "items-center")}>
              {eyebrow ? (
                <p className="inline-flex w-fit items-center gap-2 border border-primary px-3 py-1.5 font-ravioli-body text-[0.8125rem] font-semibold text-primary before:block before:size-1.5 before:bg-primary">
                  {eyebrow}
                </p>
              ) : null}
              {heading ? (
                <h1 className="max-w-[13ch] font-ravioli-display text-5xl font-semibold leading-[0.94] tracking-[-0.02em] text-balance [overflow-wrap:break-word] md:text-[5rem] md:leading-[4.75rem]">
                  {heading}
                </h1>
              ) : null}
              {description ? (
                <RavioliRichText className="max-w-[60ch] text-ink" content={description} />
              ) : null}
              {buttons?.length ? (
                <div className={cn("flex flex-wrap gap-3 pt-2", centered && "justify-center")}>
                  {buttons.map((button, index) => (
                    <RavioliAction
                      action={button}
                      className="border-primary"
                      key={`${button.href}-${index}`}
                    />
                  ))}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

HeroBackgroundImage.displayName = "Content::HeroBackgroundImage";
